export default __webpack_public_path__ + "static/media/websitevideos_2.9a23b079.png";